module.exports = __webpack_public_path__ + "static/media/DEMO_impact_admin_header.a43903e4.jpg";